module.exports = __webpack_public_path__ + "static/plane-9edaacafa3eaf1139b66168a7feebeac.jpg";